import React from 'react'

const second = () => {
  return (
    <div className='lg:container mx-auto lg:py-16 py-8 px-3'>
        <div className="second-sec flex justify-between">
            <div className='lg:w-6/12 w-[100%] flex justify-center'>
                <img src={`./sec.png`} className="lg:w-full sm:w-[500px] w-[300px]" />
            </div>
            <div className='lg:w-5/12 w-[100%] font-syne'>
                <div className='flex flex-col gap-3 h-full justify-center items-center lg:mt-0 mt-6'>
                    <img src={`./bulb-logo.png`} alt="logo"  className='w-20'/>
                    <p className='text-[#674099] text-3xl font-semibold'>About the <br></br>
                    Crystal Euro</p>
                    <p className='small'>Lorem Ipsum is simply dummy text of the  looking at its layout. The point of using Lorem Ipsum is that iprinting text heremany variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised  passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised is that iprinting text heremany variations of passages of Lorem Ipsum available, but the </p>
                    <div>
                        <button className='px-8 py-2 flex items-center gap-1 text-white bg-gradient-to-br from-[#674099] to-[#EB4F23]   rounded-lg font-syne lg:mt-8 mt-2'><small>Know More</small>
                            <span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 12L20.7071 11.2929L21.4142 12L20.7071 12.7071L20 12ZM5 13C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11V13ZM14.7071 5.29289L20.7071 11.2929L19.2929 12.7071L13.2929 6.70711L14.7071 5.29289ZM20.7071 12.7071L14.7071 18.7071L13.2929 17.2929L19.2929 11.2929L20.7071 12.7071ZM20 13H5V11H20V13Z" fill="white"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default second;
